module.exports = __webpack_public_path__ + "asset/resolution-register-pdf--9ab2ab.png";